// extracted by mini-css-extract-plugin
module.exports = {"section":"L_section__Dy8_H"};